var map = {
	"./Covd-19 Section": 143,
	"./Covd-19 Section.svg": 143,
	"./Group 1": 144,
	"./Group 1.svg": 144,
	"./Group 3": 145,
	"./Group 3.svg": 145,
	"./Group 4": 146,
	"./Group 4.svg": 146,
	"./Lab-Logo": 147,
	"./Lab-Logo.svg": 147,
	"./LabTestsLogo": 148,
	"./LabTestsLogo.png": 148,
	"./TestsInc. Logo 1": 149,
	"./TestsInc. Logo 1.svg": 149,
	"./certification": 150,
	"./certification.svg": 150,
	"./check_circle_outline-black-48dp": 151,
	"./check_circle_outline-black-48dp.svg": 151,
	"./graph": 152,
	"./graph.png": 152,
	"./heart": 153,
	"./heart.svg": 153,
	"./logo-old": 154,
	"./logo-old.png": 154,
	"./qrcode": 155,
	"./qrcode.jpeg": 155,
	"./radio_button_unchecked-24px 1": 156,
	"./radio_button_unchecked-24px 1.svg": 156,
	"./sec1": 157,
	"./sec1.svg": 157,
	"./sec2bg": 158,
	"./sec2bg.svg": 158,
	"./sec4bg": 159,
	"./sec4bg.svg": 159,
	"./tests_inc_5_200x200": 160,
	"./tests_inc_5_200x200.png": 160,
	"./tests_inc_5_200x2001": 161,
	"./tests_inc_5_200x2001.png": 161,
	"./websiteQRCode_noFrame": 162,
	"./websiteQRCode_noFrame.png": 162
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 177;